<template>
  <div class="wrap">
      <div class="ccod_join">
        <h2>视频平台</h2>
        <p>新增服务渠道，提升用户体验及服务效率。</p>
      </div>
      <div class="aiContent" style="background: #F7F8FA; display: none;">
        <h3 class="ccod_title f30" >服务优势</h3>
        <p class="ccod_titles"><span class="line"></span></p>
        <div class="ccod_AI_detail">
          <p>5G新通话系统直接对接运营商IMS网络，企业客户在现有业务流程中增加5G新通话功能，能够实现企业客户与终端用户之间音视频交互的渠道升级，IVVR流程通过接入业务系统，实现AI服务能力，客户音视频呼叫、高清视频、智能排队、资料和屏幕共享等业务处理。</p>
        </div>
         <div class="detailImg_1">
          <img src="../assets/img/p2.png" alt="">
        </div>
      </div>

    
      <div class="aiContent" style="background: #fff;">
        <h3 class="ccod_title f30" >5G新通话系统概述</h3>
        <p class="ccod_titles"><span class="line"></span></p>

        <div class="ccod_AI_detail">
          <p style="padding: 0 200px;text-indent: 4rem;line-height: 2.5rem;">5G新通话系统是公司基于电信运营商5G通信运用开发的视频通话系统。终端用户无需下载APP、无需登录入口，直接通过系统拨号键盘拨打电话号码即可进行远程高清音视频业务办理。</p>
        </div>

        <div class="detailImg_1" style="margin: 40px 100px;">
          <img src="../assets/img/video_platform2.png" alt="">
        </div>

       
      </div>

  

       <div class="aiContent" >
         <h3 class="ccod_title f30">5G消息</h3>
         <p class="ccod_titles"><span class="line"></span></p>
         <div class="ccod_AI_detail" >
           <p>基于终端原生基础短消息服务的升级，企业客户向其用户发送5G消息，构建信息服务入口。</p>
         </div>
        <div class="detailImg_1" style="margin: 40px 100px;">
          <img src="../assets/img/video_platform1.png" alt="">
        </div>
       </div>

       <div class="aiContent" >
         <h3 class="ccod_title f30">智能双录</h3>
         <p class="ccod_titles"><span class="line"></span></p>
         <div class="ccod_AI_detail" >
           <p>智能双录提供本地双录和远程双录能力，可为金融企业提供满足政策监管要求的服务过程“全流程录制可回溯”。</p>
         </div>
        <div class="detailImg_1" style="margin: 40px 100px;">
          <img src="../assets/img/video_platform3.png" alt="">
        </div>
       </div>
  </div>

</template>

<script>
export default {
    data(){
      return{

      }
    }
}
</script>

<style scoped>
  .aiContent{
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .ccod_title{
    font-weight: bold;
    margin-top: 79px;
  }
    .ccod_join{
      width: 100%;
      height: 560px;
      background: url('../assets/img/product.png') no-repeat center;
      /* background-size: 100% 100%; */
      cursor: pointer;
      overflow: hidden;
    }
    .ccod_join h2{
      color: #ffffff;
      font-size: 60px;
      font-weight: 500;
      margin-top: 207px;
      margin-bottom: 30px;
    }
    .ccod_join p{
      color: #ffffff;
      font-size: 24px;
      line-height: 36px;
    }
   
       .ccod_AI_detail{
        /* width:890px; */
      padding: 78px 0 63px;
      padding-bottom: 0;
        margin: 0 auto;
        overflow: hidden;
    }
    .ccod_AI_detail p{
        text-align: left;
        font-size: 20px;
        color:#333;
        line-height: 28px;
        /* text-indent:40px; */
    }
    .detailImg_1{
      
     margin: 54px 0 80px;
     
    }
   
  
</style>





// WEBPACK FOOTER //
// src/components/VideoPlatform.vue